import React from "react";
import axios from "axios";
import { Link } from "react-router-dom";

import './style.css';
import '../style.css'
import { API_URL, ERROR_HANDLE } from "../../../../config/constants";
import theme from "../../../../Theme/theme";
import Pagination from "../../../../components/Pagination";
import moment from "moment-timezone";
import { Constants } from "../../../../common/constants";

const IMG_TRAINER_DEFAULT = require("assets/images/anal/users-anal.png");
const NA = "--";
/**
 * An component used to list the VPT trainers.
 */
export default class Trainers extends React.Component {

    constructor(props) {
        super(props);
        let storedState = localStorage.getItem(Constants.STATE_VPT_TRAINERS);
        if (storedState)
            storedState = JSON.parse(storedState);
        this.state = storedState ? storedState : {
        trainers: [],
        loading: false,
        currentPage: 0,
        countPerPage: Constants.DEFAULT_PAGINATION_COUNT,
    };
}

componentWillUnmount() {
    localStorage.setItem(Constants.STATE_VPT_TRAINERS, JSON.stringify(this.state));
    }

    componentDidMount() {
        this.getTrainers()
    }

    searchHandler = e => {
        //Move the current page to 1, when start searching
        if (this.timeOut) clearTimeout(this.timeOut) // Hit api only if there is no event for 500 ms
        this.setState({
            ...this.state,
            currentPage: 0,
            searchQuery: e.target.value.toLowerCase()
        }, () => {
            this.timeOut = setTimeout(() => {
                this.getTrainers() // Hit api only if there is no event for 500 ms
                this.timeOut = null
            }, 500);
        });
    };

    getTrainers = () => {
        let { currentPage, countPerPage, searchQuery } = this.state
        const access_token = localStorage.getItem("access_token");
        this.setState({
            loading: true,
            trainers: []
        })
        let url = `${API_URL}/trainer/virtual_trainers?pagination=true&cpp=${countPerPage}&index=${currentPage}`
        url = searchQuery ? (url + "&search=" + encodeURIComponent(searchQuery)) : url
        axios.get(url, {
            headers: {
                "x-access-token": access_token
            }
        }).then(res => {
            return res.data
        })
            .then(data => {
                this.setState({
                    trainers: data.data ? data.data : data,
                    totalPages: data.pagination && data.pagination.total ? data.pagination.total : 1,
                    loading: false
                })
            }).catch(error => {
                this.setState({
                    loading: false
                })
                ERROR_HANDLE(error)
            })
    }

    render() {
        return (
            <div className="content">
                <div className="selector">
                    <input placeholder={"Search"} onChange={this.searchHandler} style={styles.input} />
                </div>
                {this.renderTrainers()}
                {this.renderPaginator()}
            </div>
        )
    }

    renderPaginator = () => {
        return (
            !this.state.loading && this.state.trainers.length > 0 ?
                <Pagination
                    currentPage={this.state.currentPage}
                    pageCount={this.state.totalPages}
                    rowCount={this.state.countPerPage}
                    pageAction={pageNumber => {
                        this.setState({
                            currentPage: pageNumber,
                        }, () => {
                            this.getTrainers()
                        })
                    }}
                    updateRowCount={(rowCount) => {
                        this.setState({
                            countPerPage: rowCount,
                            currentPage: 0
                        }, () => {
                            this.getTrainers()
                        })
                    }} />
                : null
        )
    }

    renderTrainers = () => {
        let { trainers, loading } = this.state;
        if (trainers.length > 0 && !loading) {
            return trainers.map(trainer => {
                return this.renderRow(trainer)
            })
        } else {
            return <div className="unselectable empty">
                {loading ? "Fetching trainers..." : "No trainers"}
            </div>
        }
    }

    renderRow = (trainer) => {
        return (
            <div className="trainer" key={trainer.id}>
                <img src={trainer.profile_picture ? trainer.profile_picture : IMG_TRAINER_DEFAULT} style={styles.image} alt="TrainerImage" />
                <div style={styles.section}>
                    <div style={styles.label}>Email
                        <div style={styles.name}>{trainer.email}</div>
                    </div>
                    <div style={styles.label}>Name
                        <div style={styles.name}>{trainer.name}</div>
                    </div>
                    <div style={styles.label}>Gender
                        <div style={styles.name}>{trainer.gender ? trainer.gender : NA}</div>
                    </div>
                </div>
                <div style={styles.section}>
                    <div style={styles.label}>Rate
                        <div style={styles.name}>{trainer.rate}</div>
                    </div>
                    <div style={styles.label}>Active
                        <div style={styles.name}>{trainer.is_active ? "Yes" : "No"}</div>
                    </div>
                </div>
                <div style={styles.section}>
                    <div style={styles.label}>Brand
                        <div style={styles.name}>{trainer.affiliated_to ? trainer.affiliated_to.name : NA}</div>
                    </div>
                    <div style={styles.label}>Private
                        <div style={styles.name}>{trainer.is_private ? "Yes" : "No"}</div>
                    </div>
                </div>
                <div style={styles.section}>
                    <div style={styles.label}>Status
                        <div style={styles.name}>{trainer.onboarding_status}</div>
                    </div>
                    <div style={styles.label}>Joined
                        <div style={styles.name}>{trainer.joined ? moment(trainer.joined).format('YYYY-DD-MM') : NA}</div>
                    </div>
                </div>
                <Link to={{
                    pathname: "/vpt/trainer/" + trainer.id,
                    state: {
                        trainer: trainer
                    }
                }}>
                    <button className="unselectable" style={styles.action}>
                        View
                    </button>
                </Link>
            </div>
        )
    }
}

const styles = {
    section: {
        flexDirection: 'row',
        flex: 1
    },
    label: {
        display: 'flex',
        flexDirection: 'row',
        textAlign: "start",
        fontFamily: theme.font.glacialIndifference,
        fontSize: 16,
        marginLeft: 10,
        color: theme.color.black,
        alignItems: 'baseline'
    },
    name: {
        color: theme.color.teal,
        marginLeft: 10,
    },
    image: {
        height: 60,
        width: 60,
        borderRadius: 30,
        marginLeft: 15,
        marginRight: 15
    },
    action: {
        margin: 30,
        backgroundColor: theme.color.teal,
        color: theme.color.white,
        paddingLeft: 20,
        paddingRight: 20,
        paddingTop: 5,
        paddingBottom: 5,
        borderRadius: 5
    },
    input: {
        display: 'flex',
        width: '50%',
        margin: 20,
        padding: 15,
        paddingLeft: 30,
        paddingRight: 30,
        backgroundColor: 'transparent',
        color: theme.color.teal,
        borderWidth: 0,
        borderRadius: 5,
        boxShadow: "2px 2px 4px 0 #D1D9E6, -2px -2px 4px 0 #D1D9E6"
    }
}